import React from 'react';

const AtomChat = () => {
  return (
    <>
      <h5>
        <b>Atom Chat</b>
      </h5>
      <p>
        Atom Chat allows you to incorporate real-time communication in your web app. The integration
        of the plugin is simple and requires no coding at all.
      </p>
      <br />
    </>
  );
};

export default AtomChat;
